import { JSX, useState, useEffect } from 'react';
import { useLocation, Navigate, Route, Routes } from 'react-router-dom';
import { InitialPageSkeleton } from '@bg-components/Skeleton';
import { useErrorHandling } from '@bg-components/ErrorBoundary/ErrorBoundaryContext';
import { authService, routeUrlGenerator } from '@bg-shared';

export const Integration = (): JSX.Element => {
    const location = useLocation();
    const triggerError = useErrorHandling();
    const [pending, setPending] = useState<boolean>(true);

    useEffect(() => {
        authService
            .reverseAuthorise(location.search)
            .then(() => {
                setPending(false);
            })
            .catch((e) => {
                triggerError(new Error(e instanceof Error ? e.message : 'Issue in integration'));
            });
    }, []);

    if (pending) {
        return <InitialPageSkeleton />;
    }

    return (
        <Routes>
            <Route path="*" element={<Navigate replace to={routeUrlGenerator.getGameUrl()} />} />
        </Routes>
    );
};
